module.exports = __webpack_public_path__ + "static/media/mobile-img.05629f6d.png";